module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/hand-8f4b626a872e53681b8bb1fe38185d65.png";